import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import SeoHead from "@/components/SeoHead";
import { SiteProvider } from "@/lib/content";

import Accueil from "@/pages/Accueil";
import MenuRedirect from "@/pages/MenuRedirect";
import GaleriePage from "@/pages/Galerie";
import ContactPage from "@/pages/Contact";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

/**
 * Site chrome (navbar, footer, floating WhatsApp) is only shown outside
 * the /admin backend. That keeps the admin surface clean and independent.
 */
function SiteChrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) return children;
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <SiteProvider>
        <SeoHead />
        <BrowserRouter>
          <ScrollToTop />
          <SiteChrome>
            <Routes>
              <Route path="/" element={<Accueil />} />
              <Route path="/menu" element={<MenuRedirect />} />
              <Route path="/galerie" element={<GaleriePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Accueil />} />
            </Routes>
          </SiteChrome>
          <Toaster
            position="top-center"
            richColors
            toastOptions={{
              style: { fontFamily: "Manrope, sans-serif", borderRadius: 4 },
            }}
          />
        </BrowserRouter>
      </SiteProvider>
    </div>
  );
}
